import { motion } from "framer-motion";
import type { Location } from "../data/locations.js";

interface LocationPinProps {
  location: Location;
  isActive: boolean;
  onClick: () => void;
}

/**
 * Small rounded-square pin matching senso-ji.jp visual style.
 * Compact numbered badge — doesn't cover illustration details.
 */
export function LocationPin({ location, isActive, onClick }: LocationPinProps) {
  return (
    <motion.button
      className="absolute outline-none cursor-pointer"
      style={{
        left: `${location.x}%`,
        top: `${location.y}%`,
        transform: "translate(-50%, -50%)",
        zIndex: isActive ? 50 : 10,
      }}
      initial={false}
      animate={isActive ? "active" : "idle"}
      whileTap={{ scale: 0.88 }}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      aria-label={`Spot ${location.number}: ${location.name}`}
    >
      <motion.div
        className="flex items-center justify-center font-bold text-white"
        variants={{
          idle: {
            width: 18,
            height: 18,
            borderRadius: 4,
            backgroundColor: "#A13A3A",
            boxShadow: "0 1px 3px rgba(0,0,0,0.35)",
          },
          active: {
            width: 24,
            height: 24,
            borderRadius: 5,
            backgroundColor: "#B76E6E",
            boxShadow: "0 2px 8px rgba(183,110,110,0.5), 0 0 0 2px #FFFFFF",
          },
        }}
        transition={{ type: "spring", stiffness: 400, damping: 25 }}
      >
        <span className="text-[10px] leading-none">{location.number}</span>
      </motion.div>
    </motion.button>
  );
}
